/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sw_Nav_Stock_In_NotesInputs */

const vi_sw_nav_stock_in_notes = /** @type {(inputs: Sw_Nav_Stock_In_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danh sách PNK`)
};

/**

* @param {Sw_Nav_Stock_In_NotesInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sw_nav_stock_in_notes = /** @type {((inputs?: Sw_Nav_Stock_In_NotesInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sw_Nav_Stock_In_NotesInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sw_nav_stock_in_notes(inputs)
});